import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { TabsSectionConsumer } from 'elements/Tabs/TabsSection/TabsSection';

import styles from './Tab.css';

const Tab = ({ children, indexKey }) => {
  const cx = classnames.bind(styles);

  return (
    <TabsSectionConsumer>
      {({ activeTab, handleClick } ) => {
        const classes = cx(
          'tab',
          {
            'active': indexKey === activeTab,
          }
        );
        return (
          <li className={classes} role={'presentation'}>
            <a
              id={`tabsSection-tab-${indexKey}`}
              href="#"
              onClick={handleClick}
              data-key={indexKey}
              role={'tab'}
              aria-selected={indexKey === activeTab}
              aria-controls={`tabsSection-container-${indexKey}`} 
            >
              {children}
            </a>
          </li>
        );
      }}
    </TabsSectionConsumer>
  );
};

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  indexKey: PropTypes.number.isRequired
};

Tab.displayName = 'Tab';

export default Tab;



// WEBPACK FOOTER //
// ./src/uis/elements/Tabs/TabsSection/Tabs/Tab/Tab.js